<h3>{{ 'CUSTOMERS.PREVIEW_EMAIL.PREVIEW_TEMPLATE' | translate }}</h3>
<mat-card class="preview-card">
  <mat-card-content [class.stencil]="loadingTemplate" class="preview-card-content">
    @if (selectedTemplateType === ReviewRequestType.email) {
      <glxy-email-viewer [html]="html" [showDevicePreviewSizeButtons]="false" class="email-viewer"></glxy-email-viewer>
    }

    @if (selectedTemplateType === ReviewRequestType.sms) {
      <div class="sms-preview">
        <img
          class="mobile-picture"
          src="https://vstatic-prod.apigateway.co/customer-voice-client.9223372035070502651.prod/assets/images/SMS-Preview-Template.png"
          alt="mobile phone"
          />
        <div class="sms-preview-content">
          <div [style.visibility]="styleVisibility(!loadingTemplate)" [innerHTML]="html | iTrustThisHtml"></div>
        </div>
      </div>
    }
  </mat-card-content>
  <!--<button mat-button (click)="editTemplate()">Edit template</button>-->
</mat-card>
